import { render } from "./VideosUploaderCompactWidget.vue?vue&type=template&id=0099d614"
import script from "./VideosUploaderCompactWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./VideosUploaderCompactWidget.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/VideosUploaderCompactWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0099d614"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0099d614', __exports__)) {
    api.reload('0099d614', __exports__)
  }
  
  module.hot.accept("./VideosUploaderCompactWidget.vue?vue&type=template&id=0099d614", () => {
    api.rerender('0099d614', render)
  })

}


export default __exports__